<template>
  <section class="catalog_main_outer">
    <div class="container flx">
      <div class="catalog_main_inner">
        <div class="news_card_wrap flx" style="justify-content: start;">
          <a :href="item.link" class="card flx" v-for="(item,index) in stocks" :key="index">
            <div class="img_wrap">
              <img :src="item.img_url" alt="news">
              <span class="name">{{item.name}}</span>
              <span class="discount to"><span>-</span>{{ item.discount }} {{ item.discount_type }}</span>
            </div>
            <div class="description_container flx">
              <div class="flx" v-if="item.start">
                <span class="qty_days green">{{item.start}}</span>
                <span class="text">до начала акции</span>
              </div>
              <div class="flx" v-else>
                <span class="qty_days orange">{{item.time_left}}</span>
                <span class="text">до конца акции</span>
              </div>
              <p>{{ item.text }}</p>
            </div>
          </a>
        </div>
        <paginate
          v-model="current_page"
          :pageCount="meta_stocks.last_page"
          :clickHandler="setPaginationPage"
          :prevText="'Предыдущая'"
          :nextText="'Следующая'"
          :containerClass="'pagination_category flx'"
          :prev-link-class="'preview angle'"
          :next-link-class="'next angle'"
          page-link-class="item"
          active-class="active"
          no-li-surround
        >
        </paginate>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'CatalogMain',
  components: {
    // ShowMoreProducts
  },
  computed: {
    ...mapState('catalog', ['sizes', 'size', 'colors', 'color', 'prices', 'price_from', 'price_to', 'perPage']),
    ...mapState('products', ['stocks', 'meta_stocks']),
    ...mapGetters('products', ['showBtnShowMore']),
    selected_size: {
      get () {
        return this.size
      },
      set (val) {
        this.setSize(val)
      }
    },
    selected_color: {
      get () {
        return this.color
      },
      set (val) {
        this.setColor(val)
      }
    },
    selected_price_from: {
      get () {
        return this.price_from
      },
      set (val) {
        this.setPriceFrom(val)
      }
    },
    selected_price_to: {
      get () {
        return this.price_to
      },
      set (val) {
        this.setPriceTo(val)
      }
    },
    current_page: {
      get () {
        return this.meta_stocks.current_page
      },
      set (val) {
        this.setPaginationPage(val)
      }
    }
  },
  methods: {
    ...mapMutations('catalog', ['setSize', 'setColor', 'clearFilters', 'setPriceFrom', 'setPriceTo', 'setPage', 'setCategoriesIds', 'clearCurrentCategory']),
    ...mapActions('catalog', ['getSizes', 'getColors', 'getCurrentCategory']),
    ...mapActions('products', ['getStocks']),
    prepare () {
      this.getSizes()
      this.getColors()
      this.clearFilters()
      // this.clearCatalogFilters()
      this.current_page = parseInt(this.$route.query.page, 10) || 1
      const categories = this.$route.query.categories
      if (categories) {
        const catIds = this.$route.query.categories.split(',')
        this.setCategoriesIds(catIds.map(id => parseInt(id)) || [])
        if (catIds.length === 1) {
          this.getCurrentCategory(parseInt(catIds[0]))
        } else {
          this.clearCurrentCategory()
        }
      }
      this.$nextTick(() => {
        this.getStocks()
      })
    },
    clearCatalogFilters () {
      this.clearFilters()
      this.getStocks()
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        const categories = to.query.categories

        if (categories) {
          const catIds = to.query.categories.split(',')
          console.log('categories ' + catIds.map(id => parseInt(id)))
          this.setCategoriesIds(catIds.map(id => parseInt(id)) || [])
        } else {
          this.setCategoriesIds([])
        }
        this.setPage(to.query.page || 1)
        this.$nextTick(() => {
          this.getStocks()
        })
      }
    }
  },
  created () {
    this.prepare()
  }
}
</script>

<style scoped>

</style>
